import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class SalesOrders_rule_outbound_order_processing_editor___ds_rule_outbound_order_processing_editorService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async get($inParams: { rule_id?: string }): Promise<{ result?: { id?: string, name?: string, description?: string, created_on?: string, created_by?: string, modified_on?: string, modified_by?: string, owner_ids?: number[], project_ids?: number[], warehouse_ids?: number[], order_class_ids?: number[], processing_strategy_workflow_code?: string, cartonization_strategy_workflow_code?: string, expand_order_line_kits?: boolean, is_active?: boolean } }> {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      rule_id?: string    }) {
      return false;
    }
}
